import {css} from "@panda/css";

export const unstyledButton = css.raw({
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    p: 0
});
import {css} from "@panda/css";

export const unstyledButton = css.raw({
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    p: 0
});
